/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'forrst': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#009e6c" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M14.914 22.574l-2.299-1.605.579-.83 1.719 1.2v-3.668h2.451v2.396l1.682-1.014.523.867-2.205 1.33v1.267l3.34-1.69.457.903-3.797 1.921v3.529h8.027L15.999 4.82 6.607 27.18h8.306z"/>'
  }
})
